import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { 
  getAllRelationalCorrelations, 
  getRelationalCorrelations,
  RelationalCorrelationResult,
  RelationalCorrelationSummary
} from '@/utils/relationalCorrelations';

export function useRelationalCorrelations(days: number = 30) {
  const [correlations, setCorrelations] = useState<RelationalCorrelationResult[]>([]);
  const [summary, setSummary] = useState<RelationalCorrelationSummary | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchCorrelations = async () => {
      setIsLoading(true);
      setError(null);
      
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) {
        setError('Please sign in to view relational correlations');
        setIsLoading(false);
        return;
      }

      try {
        const [results, summaryData] = await Promise.all([
          getAllRelationalCorrelations(user.id, days),
          getRelationalCorrelations(user.id, days)
        ]);
        setCorrelations(results);
        setSummary(summaryData);
      } catch (err) {
        console.error('Error fetching relational correlations:', err);
        setError('Failed to load relational correlations');
      }
      
      setIsLoading(false);
    };

    fetchCorrelations();
  }, [days]);

  return { correlations, summary, isLoading, error };
}
